/* global axios */
import ApiClient from './ApiClient';

class ReservationSettingsAPI extends ApiClient {
  constructor() {
    super('reservation_settings', { accountScoped: true });
  }

  save(payload) {
    return axios.put(this.url, payload);
  }
}

export default new ReservationSettingsAPI();
